<template>
  <main class="container-selfservice-main">
    <PageTitle :title="t('my_interpreter')" :subtitle="t('interpreter_scon_chat_history_description')" />
    <div class="container-filters">
      <div class="wrapper-filter">
        <InputFilter v-model="listFilterSearch" @change="getListCall" />
      </div>
      <InputSearch v-model="inputTextSearch" :placeholder="t('search_interpreter_name')" @search="getListCall(false)" />
    </div>

    <CallCardlist
      class="all-manage-con"
      v-model:is-favorite="isFavorite"
      :list-call="listCall"
      using-actions
      @select="goToInterpretation"
      @refresh="getListCall"
      @scroll-end="getListCall"
    />
  </main>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import PageTitle from '@/components/domains/self-service/payment-settings/PageTitle.vue';
import InputFilter from '@/components/shared/base/InputFilter.vue';
import InputSearch from '@/components/shared/base/InputSearch.vue';
import CallCardlist from '@/components/shared/composite/CallCardlist.vue';
import { useSelfServiceCallManage } from '@/composables/domains/self-service/useSelfServiceCallManage';
import { IResponseMultiCallsDashboard } from '@/types/response';

const { t } = useI18n();
const router = useRouter();

const { isFavorite, listCall, listFilterSearch, inputTextSearch, getListCall } = useSelfServiceCallManage();

const goToInterpretation = (info: IResponseMultiCallsDashboard) => {
  const { code = '', callType = '' } = info;
  const routeName = `ss-chat-${callType.toLowerCase()}`;

  if (code && router.hasRoute(routeName)) {
    router.push({
      name: routeName,
      query: { code: info.code, planId: info.planId },
    });
  }
};

onMounted(async () => {
  await getListCall();
});
</script>

<style scoped lang="scss">
.container-callmanage-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.container-filters {
  display: flex;
  gap: 1rem;
  width: 100%;
  align-items: flex-end;
  justify-content: space-between;

  p,
  label {
    white-space: nowrap;
  }
  @include respond-to(mobile-landscape) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.wrapper-filter {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  @include respond-to(mobile-landscape) {
    width: 100%;
  }
}

// ::v-deep(.search-container) {
//   width: unset;
// }
</style>
